import { chakra, Box, Text, Link } from "@chakra-ui/react";
import { space } from "theme/themeConfig";

export const Wrapper = chakra(Box, {
  baseStyle: {
    pt: "1.125rem",
    pb: 2,
    pl: 0,
    pr: 3,
    mt: 1,
    display: "flex",
    borderRadius: "2px"
  }
});

export const ContactLink = chakra(Link, {
  baseStyle: {
    textDecoration: "underline",
    "&:hover, &:focus": {
      textDecoration: "underline"
    }
  }
});

export const BannerCopy = chakra(Text, {
  baseStyle: {
    letterSpacing: "0.01rem",
    mt: space[-3],
    lineHeight: { base: space[1.5], md: space[1] }
  }
});
